<template>
  <section class="bg-tw-sand" :aria-label="t('label')">
    <ul class="mx-auto grid max-w-[1280px] gap-6 px-6 py-10 text-center text-2xl font-semibold tracking-[-0.02em] text-black md:grid-cols-3 md:px-20 md:py-[62px]">
      <li v-for="key in ['free', 'classroom', 'research']" :key="key">{{ t(key) }}</li>
    </ul>
  </section>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n({
    messages: {
      no: {
        label: 'Om Samtavla',
        free: 'Gratis å bruke',
        classroom: 'For klasserom og forelesninger',
        research: 'Forskningsbasert',
      },
      en: {
        label: 'About Talkwall',
        free: 'Free to use',
        classroom: 'For classrooms and lectures',
        research: 'Research-based',
      },
    },
  })
</script>
